var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#cardProcessingModal .modal-body[data-v-d0e820ec] {\n  height: 65vh;\n  overflow-y: auto;\n}\n\n#card_page[data-v-d0e820ec] {\n  position: absolute;\n  height: 100%;\n  width: 94.4%;\n  border: none;\n}\n\n@font-face {\n  font-family: \"password\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"/iframev2/assets/fonts/password.ttf\");\n}\n\ninput.key[data-v-d0e820ec] {\n  font-family: \"password\";\n  width: 100px;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "cards",
  props: ["status_api_url", "invoice_no", "callback_url"],
  data: function data() {
    return {
      mpgs_url: null,
      mastercard: null,
      visa: null,
      eYear: null,
      eMonth: null,
      CardNo: null,
      CVV: null,
      uierrors: [],
      cvv_error: null,
      month_error: null,
      cardno_error: null,
      year_error: null,
      currency: null,
      logo: null,
      invoice_amount: 0,
      agent_fee: 0,
      fee: 0,
      total_amount: 0,
      bill_ref: null,
      service_id: null,
      card_charges: 0,
      expiry: null,
      gateway_id: null
    };
  },

  computed: {
    expiry_month: function expiry_month() {
      if (this.expiry) {
        var split_expiry = this.expiry.split("/");
        return split_expiry[0].trim();
      }
    },
    expiry_year: function expiry_year() {
      if (this.expiry) {
        var split_expiry = this.expiry.split("/");
        return split_expiry[1].trim();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    $("#cardModal").on("shown.bs.modal", function () {
      _this.clear_form();
      _this.mount_card_js();
    });

    $("#cardProcessingModal").on("shown.bs.modal", function () {});

    $("#cardProcessingModal").on("hidden.bs.modal", function () {
      var ifr = window.top.$("#card_page");
      ifr.attr("src", "about:blank");
    });

    $("#cardModal").on("hidden.bs.modal", function () {
      $("#jswrapper").remove();
      _this.clear_form();
      _this.destroyTimer();
    });
    this.mpgs_url = this.$attrs["mpgs_api_url"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.logo = this.$attrs["logo"];
    this.bill_ref = this.$attrs["bill_ref"];
    this.service_id = this.$attrs["service_id"];
    this.gateway_id = this.$attrs["gid"];
    this.set_total_amount();
    this.calculate_card_charges();
  },
  methods: {
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },

    load_iframe: function load_iframe() {
      if (this.eYear.length <= 0 || this.eMonth.length <= 0) {
        this.year_error = "invalid expiry";
        return;
      }
      $("#cardModal .close").click();
      $("#cardProcessingModal").modal("show");
    },
    mount_card_js: function mount_card_js() {
      $("#cardjswrapper").append('<div id="jswrapper" class="card-wrapper"></div>');

      new Card({
        form: "#frmCard",
        container: ".card-wrapper",

        formSelectors: {
          numberInput: "input#CardNo",
          expiryInput: "input#expiry",
          cvcInput: "input#CVV",
          nameInput: "input#name" },

        width: "350px",
        formatting: true,
        messages: {
          validDate: "Valid\nThru",
          monthYear: "month/year" },

        placeholders: {
          CardNo: "•••• •••• •••• ••••",
          name: "",
          expiry: ""
        },

        masks: {},

        debug: false });
    },
    clear_form: function clear_form() {
      $("#frmCard").trigger("reset");
      this.eYear = "";
      this.CardNo = "";
      this.CVV = "";
      this.eMonth = "";
      this.uierrors = [];
      this.year_error = "";
      this.cvv_error = "";
      this.month_error = "";
      this.cardno_error = "";
      this.expiry = null;
    },
    check_validation: function check_validation(e) {
      this.set_month_and_year();
      this.checkForm(e);
    },
    set_total_amount: function set_total_amount() {
      this.total_amount = this.set_card_charges(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },
    calculate_due_amount_less_charges: function calculate_due_amount_less_charges() {},
    set_month_and_year: function set_month_and_year() {
      if (this.expiry) {
        var split_expiry = this.expiry.split("/");
        this.eMonth = split_expiry[0].trim();
        this.eYear = split_expiry[1].trim();
      }
    },

    calculate_card_charges: function calculate_card_charges() {
      var val = this.total_amount - (parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
      this.card_charges = val.toFixed(2);
    },
    set_card_charges: function set_card_charges(base_amount) {
      var a = base_amount * this.$attrs["charges"] / 100;
      var val = a + base_amount;
      return val.toFixed(2);
    },
    checkForm: function checkForm(e) {
      this.uierrors = [];
      this.year_error = "";
      this.cvv_error = "";
      this.month_error = "";
      this.cardno_error = "";

      if (!this.eYear) {
        this.uierrors.push("Year is required");
        this.year_error = "Required*";
      }
      if (!this.eMonth) {
        this.uierrors.push("Month is required");
        this.month_error = "Required*";
      }
      if (!this.CardNo) {
        this.uierrors.push("Card Number is required");
        this.cardno_error = "Required*";
      }
      if (!this.CVV) {
        this.uierrors.push("CVV is required");
        this.cvv_error = "Required*";
      }

      if (!this.uierrors.length) {
        return true;
      }

      e.preventDefault();
    },

    destroy: function destroy(e) {
      $("#cardProcessingModal").modal("hide");
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"cardProcessingModal","aria-labelledby":"cardProcessingModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center",attrs:{"id":"option_buttons"}},[_c('complete-button',{ref:"timer",attrs:{"gateway":"cards","status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"callback_url":_vm.callback_url},on:{"click":_vm.destroy}}),_vm._v(" "),_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"cardModal","tabindex":"-1","role":"dialog","aria-labelledby":"cardModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('form',{attrs:{"id":"frmCard","action":_vm.mpgs_url,"method":"POST","target":"card_page"},on:{"submit":_vm.load_iframe}},[_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay using Card")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                        "+_vm._s(_vm.currency)+"\n                        "+_vm._s((_vm.total_amount - _vm.card_charges).toFixed(2))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Card Charges*")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                        "+_vm._s(_vm.currency)+" "+_vm._s(_vm.card_charges)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Total Due*")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                        "+_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"cardjswrapper"}}),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"15px"}},[_c('label',[_vm._v("Card Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.CardNo),expression:"CardNo"}],staticClass:"form-control",attrs:{"type":"text","id":"CardNo","name":"cardNo","placeholder":"1234 1234 1234 1234","required":""},domProps:{"value":(_vm.CardNo)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.CardNo=$event.target.value},_vm.check_validation]}}),_vm._v(" "),(_vm.cardno_error)?_c('p',{staticStyle:{"color":"red"}},[_vm._v("\n                          "+_vm._s(_vm.cardno_error)+"\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Valid Thru")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expiry),expression:"expiry"}],staticClass:"form-control",attrs:{"placeholder":"MM/YY","id":"expiry","type":"tel","maxlength":"7","required":""},domProps:{"value":(_vm.expiry)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.expiry=$event.target.value},_vm.check_validation]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expiry_month),expression:"expiry_month"}],attrs:{"type":"hidden","name":"eMonth"},domProps:{"value":(_vm.expiry_month)},on:{"input":function($event){if($event.target.composing){ return; }_vm.expiry_month=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expiry_year),expression:"expiry_year"}],attrs:{"type":"hidden","name":"eYear"},domProps:{"value":(_vm.expiry_year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.expiry_year=$event.target.value}}}),_vm._v(" "),(_vm.year_error)?_c('p',{staticStyle:{"color":"red"}},[_vm._v("\n                            "+_vm._s(_vm.year_error)+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Card Code (CVC)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.CVV),expression:"CVV"}],staticClass:"key form-control",attrs:{"type":"text","id":"CVV","name":"CVV","placeholder":"CVC","required":""},domProps:{"value":(_vm.CVV)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.CVV=$event.target.value},_vm.check_validation]}}),_vm._v(" "),(_vm.cvv_error)?_c('p',{staticStyle:{"color":"red"}},[_vm._v("\n                            "+_vm._s(_vm.cvv_error)+"\n                          ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"submit","data-toggle":"modal","value":"Pay","data-target":".cardProcessingModal"},on:{"submit":function($event){_vm.check_validation();
                        return;}}})])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"MerchantTrxRef"},domProps:{"value":_vm.bill_ref}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"serviceID"},domProps:{"value":_vm.service_id}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency"},domProps:{"value":_vm.currency}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"amount"},domProps:{"value":_vm.total_amount}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"gateway_id"},domProps:{"value":_vm.gateway_id}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"invoiceNumber"},domProps:{"value":_vm.invoice_no}})])])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v("\n              Processing your payment, please wait...\n            ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('span',[_vm._v("Do not close this window until your payment processing is\n              complete.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('iframe',{staticStyle:{"background":"#fff"},attrs:{"id":"card_page","width":"80%","height":"100%","name":"card_page","frameborder":"0"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
__vue__options__._scopeId = "data-v-d0e820ec"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0e820ec", __vue__options__)
  } else {
    hotAPI.reload("data-v-d0e820ec", __vue__options__)
  }
})()}